const cartDrawerContainer = document.getElementById('shopify-section-cart-drawer');

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
      document.body.classList.add('overflow-hidden');
    }
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    cartDrawerContainer.style.display = 'block';
    setTimeout(() => {
      this.classList.add('animate', 'active');
    },200);

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty')? this.querySelector('.drawer__inner-empty'): document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    },
    { once: true }
    );
    
    // below line is commented to resolve page stuck issue
    // document.body.classList.add('overflow-hidden');
  }

  openCustom(openDrawer = true) {
    fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
        .then(response => response.json())
        .then(response => {
          this.renderContentsCustom(response, openDrawer);
        })
        .catch(error => console.error('Error fetching cart data:', error));
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  async renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    let cartCheckoutButton = document.querySelector('.gokwik-checkout');
    // if(cartCheckoutButton) {
    //   cartCheckoutButton.setAttribute('aria-disabled',"true");
    //   cartCheckoutButton.style.pointerEvents = "none";
    // }
    // initializeCartCarousel();
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
    const response = await fetch('/cart.js');
    if (!response.ok) {
      console.log('Network response was not ok');
    }
    const cart = await response.json();
    const cartPrice = parseInt(cart.original_total_price / 100);
    const discountCouponApplied = localStorage.getItem('discountCode');
    if (cartPrice && cartPrice < 1000 && discountCouponApplied) {
      await removeDiscount();
      localStorage.removeItem('discountCode');
    } else if (cartPrice && cartPrice >= 1000 && discountCouponApplied) {
      const discountCode = JSON.parse(discountCouponApplied);
      const couponText = document.querySelector('.cart-coupon-button text');
      if (couponText) {
        couponText.innerHTML = `${discountCode.code} APPLIED`;
      }
    }

    let noDiscount = document.querySelector('.no-coupon');
    if(noDiscount){
      let cartCoupon = document.querySelector('.cart-coupon-button');
      let texts = Array.from(cartCoupon.querySelectorAll('text'));
      texts.forEach((text)=>{
        text.classList.add('hidden')
      })
    }
  }

  renderContentsCustom(parsedState, openDrawer) {
    document.querySelector('#CartDrawer .drawer__inner').classList.contains('is-empty') &&
      document.querySelector('#CartDrawer .drawer__inner').classList.remove('is-empty');
    //this.productId = parsedState.id;
    document.querySelector('cart-drawer').getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);   
      
      sectionElement.innerHTML = document.querySelector('cart-drawer').getSectionInnerHTML(parsedState[section.id], section.selector);
    });
    
    var __html = new DOMParser().parseFromString(parsedState['cart-drawer'], 'text/html').getElementsByClassName("custom-cart")[0];
    
    const customCartElement = document.getElementsByClassName("custom-cart")[0];
    if (__html.classList.contains("is-empty")) {
        customCartElement.classList.add('is-empty');
    } else {
        customCartElement.classList.remove('is-empty');
    }
    
    // initializeCartCarousel();
    setTimeout(() => {
      document.querySelector('#CartDrawer #CartDrawer-Overlay').addEventListener('click', this.close.bind(this));

      if (openDrawer) {
        this.open();
      }
    });
  }
  
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function openCartDrawer() {
  const cartDrawer = document.querySelector('.custom-cart');
  const cartDrawerWrapper = document.querySelector('#shopify-section-cart-drawer');

  if (cartDrawer) {
    cartDrawerWrapper.style.display = "block";
    cartDrawer.style.display = "flex";

    setTimeout(() => {
      cartDrawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    }, 200);
  }
}

// Attach listener to the button (safe, no duplicates)
function attachViewCartListener() {
  const btns = document.querySelectorAll('#view-cart-drawer');

  btns.forEach(btn => {
    // Remove old listener by cloning
    const clone = btn.cloneNode(true);
    btn.replaceWith(clone);

    // Add fresh listener
    clone.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  });

  console.log("View-cart listener attached");
}

// Run on page load
document.addEventListener("DOMContentLoaded", attachViewCartListener);

// Run on variant change
document.querySelectorAll('variant-selects').forEach(variantEl => {
  variantEl.addEventListener('change', function () {
    attachViewCartListener();
    console.log("Listener re-attached after variant change");
  });
});

